import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfileState } from "./types";
import { TProfileData } from "../types";
import { EMPTY_PROFILE } from "../constants";
import { loadProfile } from "../helpers";

const initialState: ProfileState = { profile: loadProfile() };

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<Partial<TProfileData>>) {
      Object.assign(state.profile, action.payload);
    },
    resetProfile(state) {
      state.profile = EMPTY_PROFILE;
    },
  },
});

export const profileReducers = profileSlice.reducer;
export const { setProfile, resetProfile } = profileSlice.actions;
